export default __webpack_public_path__ + "static/media/asset2.d7dc3877.png";